module.exports = __webpack_public_path__ + "static/media/damages.a7a7a0f2.svg";